import { render, staticRenderFns } from "./Point_Profile.vue?vue&type=template&id=0a9a52da&scoped=true"
import script from "./Point_Profile.vue?vue&type=script&lang=js"
export * from "./Point_Profile.vue?vue&type=script&lang=js"
import style0 from "./Point_Profile.vue?vue&type=style&index=0&id=0a9a52da&prod&lang=css"
import style1 from "./Point_Profile.vue?vue&type=style&index=1&id=0a9a52da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a52da",
  null
  
)

export default component.exports